import React from 'react';
import classnames from 'classnames/bind';
import { currentZone } from '@portal-root/geo-utils';
import { ECountries } from '@/_types';
import { WbPartnersLogo } from './_components/wb-partners-logo';
import { WbPartnersLogoTr } from './_components/wb-partners-logo-tr';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Logo';

export const Logo = () => {
  const isTurkey = currentZone.endsWith(ECountries.TR);

  return (
    <div className={cn(BLOCK_NAME)}>
      {isTurkey ? <WbPartnersLogoTr /> : <WbPartnersLogo />}
    </div>
  );
};
